var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "accessibility-statement",
      attrs: { role: "main", "aria-labelledby": "accessibility-title" },
    },
    [
      _c("header", { staticClass: "statement-header" }, [
        _c("h1", { attrs: { id: "accessibility-title" } }, [
          _vm._v(
            "\n      " +
              _vm._s(
                _vm.$t(
                  "accessibility.statement.title",
                  "Accessibility Statement"
                )
              ) +
              "\n    "
          ),
        ]),
        _vm._v(" "),
        _c("p", { staticClass: "statement-intro" }, [
          _vm._v(
            "\n      " +
              _vm._s(
                _vm.$t(
                  "accessibility.statement.intro",
                  "This accessibility statement applies to the GOZ-App website and gaming platform."
                )
              ) +
              "\n    "
          ),
        ]),
      ]),
      _vm._v(" "),
      _c("main", { staticClass: "statement-content" }, [
        _c(
          "section",
          {
            staticClass: "statement-section",
            attrs: { "aria-labelledby": "compliance-heading" },
          },
          [
            _c("h2", { attrs: { id: "compliance-heading" } }, [
              _vm._v(
                "\n        " +
                  _vm._s(
                    _vm.$t(
                      "accessibility.compliance.title",
                      "Accessibility Compliance"
                    )
                  ) +
                  "\n      "
              ),
            ]),
            _vm._v(" "),
            _c("p", [
              _vm._v(
                "\n        " +
                  _vm._s(
                    _vm.$t(
                      "accessibility.compliance.description",
                      "We are committed to ensuring that our website is accessible to everyone. This website has been designed and developed to conform to the European Accessibility Act (EAA) and Web Content Accessibility Guidelines (WCAG) 2.1 Level AA."
                    )
                  ) +
                  "\n      "
              ),
            ]),
            _vm._v(" "),
            _c("h3", [
              _vm._v(
                _vm._s(
                  _vm.$t(
                    "accessibility.standards.title",
                    "Standards Compliance"
                  )
                )
              ),
            ]),
            _vm._v(" "),
            _c("ul", [
              _c("li", [
                _vm._v(
                  _vm._s(
                    _vm.$t(
                      "accessibility.standards.eaa",
                      "European Accessibility Act (EAA) 2025"
                    )
                  )
                ),
              ]),
              _vm._v(" "),
              _c("li", [
                _vm._v(
                  _vm._s(
                    _vm.$t(
                      "accessibility.standards.wcag",
                      "Web Content Accessibility Guidelines (WCAG) 2.1 Level AA"
                    )
                  )
                ),
              ]),
              _vm._v(" "),
              _c("li", [
                _vm._v(
                  _vm._s(
                    _vm.$t(
                      "accessibility.standards.en301549",
                      "EN 301 549 - Accessibility requirements for ICT procurement"
                    )
                  )
                ),
              ]),
            ]),
          ]
        ),
        _vm._v(" "),
        _c(
          "section",
          {
            staticClass: "statement-section",
            attrs: { "aria-labelledby": "features-heading" },
          },
          [
            _c("h2", { attrs: { id: "features-heading" } }, [
              _vm._v(
                "\n        " +
                  _vm._s(
                    _vm.$t(
                      "accessibility.features.title",
                      "Accessibility Features"
                    )
                  ) +
                  "\n      "
              ),
            ]),
            _vm._v(" "),
            _c("h3", [
              _vm._v(
                _vm._s(
                  _vm.$t(
                    "accessibility.features.keyboard.title",
                    "Keyboard Navigation"
                  )
                )
              ),
            ]),
            _vm._v(" "),
            _c("ul", [
              _c("li", [
                _vm._v(
                  _vm._s(
                    _vm.$t(
                      "accessibility.features.keyboard.full",
                      "Full keyboard navigation support without requiring a mouse"
                    )
                  )
                ),
              ]),
              _vm._v(" "),
              _c("li", [
                _vm._v(
                  _vm._s(
                    _vm.$t(
                      "accessibility.features.keyboard.skip",
                      "Skip navigation links for efficient page navigation"
                    )
                  )
                ),
              ]),
              _vm._v(" "),
              _c("li", [
                _vm._v(
                  _vm._s(
                    _vm.$t(
                      "accessibility.features.keyboard.focus",
                      "Visible focus indicators for all interactive elements"
                    )
                  )
                ),
              ]),
              _vm._v(" "),
              _c("li", [
                _vm._v(
                  _vm._s(
                    _vm.$t(
                      "accessibility.features.keyboard.escape",
                      "Escape key closes modals and dialogs"
                    )
                  )
                ),
              ]),
            ]),
            _vm._v(" "),
            _c("h3", [
              _vm._v(
                _vm._s(
                  _vm.$t(
                    "accessibility.features.screen_reader.title",
                    "Screen Reader Support"
                  )
                )
              ),
            ]),
            _vm._v(" "),
            _c("ul", [
              _c("li", [
                _vm._v(
                  _vm._s(
                    _vm.$t(
                      "accessibility.features.screen_reader.aria",
                      "Comprehensive ARIA labels and descriptions"
                    )
                  )
                ),
              ]),
              _vm._v(" "),
              _c("li", [
                _vm._v(
                  _vm._s(
                    _vm.$t(
                      "accessibility.features.screen_reader.landmarks",
                      "Semantic HTML landmarks for easy navigation"
                    )
                  )
                ),
              ]),
              _vm._v(" "),
              _c("li", [
                _vm._v(
                  _vm._s(
                    _vm.$t(
                      "accessibility.features.screen_reader.announcements",
                      "Live region announcements for dynamic content changes"
                    )
                  )
                ),
              ]),
              _vm._v(" "),
              _c("li", [
                _vm._v(
                  _vm._s(
                    _vm.$t(
                      "accessibility.features.screen_reader.alt",
                      "Descriptive alternative text for all images"
                    )
                  )
                ),
              ]),
            ]),
            _vm._v(" "),
            _c("h3", [
              _vm._v(
                _vm._s(
                  _vm.$t(
                    "accessibility.features.visual.title",
                    "Visual Accessibility"
                  )
                )
              ),
            ]),
            _vm._v(" "),
            _c("ul", [
              _c("li", [
                _vm._v(
                  _vm._s(
                    _vm.$t(
                      "accessibility.features.visual.contrast",
                      "High color contrast ratios (4.5:1 for normal text, 3:1 for large text)"
                    )
                  )
                ),
              ]),
              _vm._v(" "),
              _c("li", [
                _vm._v(
                  _vm._s(
                    _vm.$t(
                      "accessibility.features.visual.color",
                      "Information conveyed through multiple means, not color alone"
                    )
                  )
                ),
              ]),
              _vm._v(" "),
              _c("li", [
                _vm._v(
                  _vm._s(
                    _vm.$t(
                      "accessibility.features.visual.zoom",
                      "Support for zoom up to 400% without loss of functionality"
                    )
                  )
                ),
              ]),
              _vm._v(" "),
              _c("li", [
                _vm._v(
                  _vm._s(
                    _vm.$t(
                      "accessibility.features.visual.motion",
                      "Respect for reduced motion preferences"
                    )
                  )
                ),
              ]),
            ]),
            _vm._v(" "),
            _c("h3", [
              _vm._v(
                _vm._s(
                  _vm.$t(
                    "accessibility.features.forms.title",
                    "Form Accessibility"
                  )
                )
              ),
            ]),
            _vm._v(" "),
            _c("ul", [
              _c("li", [
                _vm._v(
                  _vm._s(
                    _vm.$t(
                      "accessibility.features.forms.labels",
                      "Explicit labels for all form controls"
                    )
                  )
                ),
              ]),
              _vm._v(" "),
              _c("li", [
                _vm._v(
                  _vm._s(
                    _vm.$t(
                      "accessibility.features.forms.errors",
                      "Clear error messages associated with form fields"
                    )
                  )
                ),
              ]),
              _vm._v(" "),
              _c("li", [
                _vm._v(
                  _vm._s(
                    _vm.$t(
                      "accessibility.features.forms.required",
                      "Required field indication"
                    )
                  )
                ),
              ]),
              _vm._v(" "),
              _c("li", [
                _vm._v(
                  _vm._s(
                    _vm.$t(
                      "accessibility.features.forms.autocomplete",
                      "Autocomplete support for sensitive fields"
                    )
                  )
                ),
              ]),
            ]),
          ]
        ),
        _vm._v(" "),
        _c(
          "section",
          {
            staticClass: "statement-section",
            attrs: { "aria-labelledby": "testing-heading" },
          },
          [
            _c("h2", { attrs: { id: "testing-heading" } }, [
              _vm._v(
                "\n        " +
                  _vm._s(
                    _vm.$t(
                      "accessibility.testing.title",
                      "Testing and Validation"
                    )
                  ) +
                  "\n      "
              ),
            ]),
            _vm._v(" "),
            _c("p", [
              _vm._v(
                "\n        " +
                  _vm._s(
                    _vm.$t(
                      "accessibility.testing.description",
                      "Our accessibility compliance is validated through:"
                    )
                  ) +
                  "\n      "
              ),
            ]),
            _vm._v(" "),
            _c("ul", [
              _c("li", [
                _vm._v(
                  _vm._s(
                    _vm.$t(
                      "accessibility.testing.automated",
                      "Automated testing with axe-core and Lighthouse"
                    )
                  )
                ),
              ]),
              _vm._v(" "),
              _c("li", [
                _vm._v(
                  _vm._s(
                    _vm.$t(
                      "accessibility.testing.manual",
                      "Manual testing with keyboard navigation"
                    )
                  )
                ),
              ]),
              _vm._v(" "),
              _c("li", [
                _vm._v(
                  _vm._s(
                    _vm.$t(
                      "accessibility.testing.screen_readers",
                      "Screen reader testing (NVDA, JAWS, VoiceOver)"
                    )
                  )
                ),
              ]),
              _vm._v(" "),
              _c("li", [
                _vm._v(
                  _vm._s(
                    _vm.$t(
                      "accessibility.testing.users",
                      "Usability testing with people with disabilities"
                    )
                  )
                ),
              ]),
            ]),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass: "compliance-status",
                attrs: { role: "status", "aria-live": "polite" },
              },
              [
                _c("h3", [
                  _vm._v(
                    _vm._s(
                      _vm.$t(
                        "accessibility.status.title",
                        "Current Compliance Status"
                      )
                    )
                  ),
                ]),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "status-indicator" },
                  [
                    _c(
                      "v-icon",
                      {
                        attrs: {
                          color: "success",
                          size: "24",
                          "aria-hidden": "true",
                        },
                      },
                      [_vm._v("\n            fas fa-check-circle\n          ")]
                    ),
                    _vm._v(" "),
                    _c("span", { staticClass: "status-text" }, [
                      _vm._v(
                        "\n            " +
                          _vm._s(
                            _vm.$t(
                              "accessibility.status.compliant",
                              "Fully Compliant with EAA and WCAG 2.1 AA"
                            )
                          ) +
                          "\n          "
                      ),
                    ]),
                  ],
                  1
                ),
                _vm._v(" "),
                _c("p", { staticClass: "status-date" }, [
                  _vm._v(
                    "\n          " +
                      _vm._s(
                        _vm.$t("accessibility.status.updated", "Last updated:")
                      ) +
                      " \n          " +
                      _vm._s(_vm.formattedDate) +
                      "\n        "
                  ),
                ]),
              ]
            ),
          ]
        ),
        _vm._v(" "),
        _c(
          "section",
          {
            staticClass: "statement-section",
            attrs: { "aria-labelledby": "issues-heading" },
          },
          [
            _c("h2", { attrs: { id: "issues-heading" } }, [
              _vm._v(
                "\n        " +
                  _vm._s(
                    _vm.$t(
                      "accessibility.issues.title",
                      "Known Issues and Limitations"
                    )
                  ) +
                  "\n      "
              ),
            ]),
            _vm._v(" "),
            _vm.knownIssues.length === 0
              ? _c(
                  "div",
                  { staticClass: "no-issues" },
                  [
                    _c(
                      "v-icon",
                      {
                        attrs: {
                          color: "success",
                          size: "20",
                          "aria-hidden": "true",
                        },
                      },
                      [_vm._v("\n          fas fa-check\n        ")]
                    ),
                    _vm._v(
                      "\n        " +
                        _vm._s(
                          _vm.$t(
                            "accessibility.issues.none",
                            "No known accessibility issues at this time."
                          )
                        ) +
                        "\n      "
                    ),
                  ],
                  1
                )
              : _c(
                  "ul",
                  _vm._l(_vm.knownIssues, function (issue) {
                    return _c(
                      "li",
                      { key: issue.id, staticClass: "issue-item" },
                      [
                        _c("strong", [_vm._v(_vm._s(issue.title))]),
                        _vm._v(
                          ": " + _vm._s(issue.description) + "\n          "
                        ),
                        _c("span", { staticClass: "issue-status" }, [
                          _vm._v(_vm._s(issue.status)),
                        ]),
                      ]
                    )
                  }),
                  0
                ),
          ]
        ),
        _vm._v(" "),
        _c(
          "section",
          {
            staticClass: "statement-section",
            attrs: { "aria-labelledby": "contact-heading" },
          },
          [
            _c("h2", { attrs: { id: "contact-heading" } }, [
              _vm._v(
                "\n        " +
                  _vm._s(
                    _vm.$t(
                      "accessibility.contact.title",
                      "Accessibility Feedback and Contact"
                    )
                  ) +
                  "\n      "
              ),
            ]),
            _vm._v(" "),
            _c("p", [
              _vm._v(
                "\n        " +
                  _vm._s(
                    _vm.$t(
                      "accessibility.contact.description",
                      "We welcome your feedback on the accessibility of this website. Please let us know if you encounter accessibility barriers:"
                    )
                  ) +
                  "\n      "
              ),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "contact-methods" }, [
              _c("h3", [
                _vm._v(
                  _vm._s(
                    _vm.$t("accessibility.contact.methods", "How to Contact Us")
                  )
                ),
              ]),
              _vm._v(" "),
              _c("ul", [
                _c("li", [
                  _c("strong", [
                    _vm._v(
                      _vm._s(_vm.$t("accessibility.contact.email", "Email:"))
                    ),
                  ]),
                  _vm._v(" "),
                  _c("a", { attrs: { href: "mailto:accessibility@goz.fun" } }, [
                    _vm._v("accessibility@goz.fun"),
                  ]),
                ]),
                _vm._v(" "),
                _c("li", [
                  _c("strong", [
                    _vm._v(
                      _vm._s(_vm.$t("accessibility.contact.phone", "Phone:"))
                    ),
                  ]),
                  _vm._v(" "),
                  _c("a", { attrs: { href: "tel:+1234567890" } }, [
                    _vm._v("+1 (234) 567-8890"),
                  ]),
                ]),
                _vm._v(" "),
                _c("li", [
                  _c("strong", [
                    _vm._v(
                      _vm._s(
                        _vm.$t(
                          "accessibility.contact.address",
                          "Postal Address:"
                        )
                      )
                    ),
                  ]),
                  _vm._v(" "),
                  _vm._m(0),
                ]),
              ]),
              _vm._v(" "),
              _c("p", [
                _vm._v(
                  "\n          " +
                    _vm._s(
                      _vm.$t(
                        "accessibility.contact.response",
                        "We aim to respond to accessibility feedback within 5 business days."
                      )
                    ) +
                    "\n        "
                ),
              ]),
            ]),
          ]
        ),
        _vm._v(" "),
        _c(
          "section",
          {
            staticClass: "statement-section",
            attrs: { "aria-labelledby": "legal-heading" },
          },
          [
            _c("h2", { attrs: { id: "legal-heading" } }, [
              _vm._v(
                "\n        " +
                  _vm._s(
                    _vm.$t("accessibility.legal.title", "Legal Information")
                  ) +
                  "\n      "
              ),
            ]),
            _vm._v(" "),
            _c("p", [
              _vm._v(
                "\n        " +
                  _vm._s(
                    _vm.$t(
                      "accessibility.legal.directive",
                      "This accessibility statement is prepared in accordance with the European Accessibility Act (Directive (EU) 2019/882) and applies to this website."
                    )
                  ) +
                  "\n      "
              ),
            ]),
            _vm._v(" "),
            _c("h3", [
              _vm._v(
                _vm._s(
                  _vm.$t(
                    "accessibility.legal.enforcement.title",
                    "Enforcement Procedure"
                  )
                )
              ),
            ]),
            _vm._v(" "),
            _c("p", [
              _vm._v(
                "\n        " +
                  _vm._s(
                    _vm.$t(
                      "accessibility.legal.enforcement.description",
                      "If you are not satisfied with our response to your accessibility concern, you may contact the relevant enforcement body in your EU member state."
                    )
                  ) +
                  "\n      "
              ),
            ]),
            _vm._v(" "),
            _c("h3", [
              _vm._v(
                _vm._s(
                  _vm.$t(
                    "accessibility.legal.scope.title",
                    "Scope of this Statement"
                  )
                )
              ),
            ]),
            _vm._v(" "),
            _c("p", [
              _vm._v(
                "\n        " +
                  _vm._s(
                    _vm.$t(
                      "accessibility.legal.scope.description",
                      "This statement covers the GOZ-App website and gaming platform, including all pages, features, and functionality accessible through goz.fun domain."
                    )
                  ) +
                  "\n      "
              ),
            ]),
          ]
        ),
        _vm._v(" "),
        _c(
          "section",
          {
            staticClass: "statement-section",
            attrs: { "aria-labelledby": "technical-heading" },
          },
          [
            _c("h2", { attrs: { id: "technical-heading" } }, [
              _vm._v(
                "\n        " +
                  _vm._s(
                    _vm.$t(
                      "accessibility.technical.title",
                      "Technical Information"
                    )
                  ) +
                  "\n      "
              ),
            ]),
            _vm._v(" "),
            _c("h3", [
              _vm._v(
                _vm._s(
                  _vm.$t(
                    "accessibility.technical.compatibility.title",
                    "Browser and Assistive Technology Compatibility"
                  )
                )
              ),
            ]),
            _vm._v(" "),
            _c("p", [
              _vm._v(
                "\n        " +
                  _vm._s(
                    _vm.$t(
                      "accessibility.technical.compatibility.description",
                      "This website is designed to be compatible with the following assistive technologies:"
                    )
                  ) +
                  "\n      "
              ),
            ]),
            _vm._v(" "),
            _c("ul", [
              _c("li", [
                _vm._v(
                  _vm._s(
                    _vm.$t(
                      "accessibility.technical.browsers",
                      "Modern web browsers (Chrome, Firefox, Safari, Edge)"
                    )
                  )
                ),
              ]),
              _vm._v(" "),
              _c("li", [
                _vm._v(
                  _vm._s(
                    _vm.$t(
                      "accessibility.technical.screen_readers",
                      "Screen readers (NVDA, JAWS, VoiceOver, TalkBack)"
                    )
                  )
                ),
              ]),
              _vm._v(" "),
              _c("li", [
                _vm._v(
                  _vm._s(
                    _vm.$t(
                      "accessibility.technical.keyboard",
                      "Keyboard navigation"
                    )
                  )
                ),
              ]),
              _vm._v(" "),
              _c("li", [
                _vm._v(
                  _vm._s(
                    _vm.$t(
                      "accessibility.technical.voice",
                      "Voice recognition software"
                    )
                  )
                ),
              ]),
              _vm._v(" "),
              _c("li", [
                _vm._v(
                  _vm._s(
                    _vm.$t(
                      "accessibility.technical.zoom",
                      "Screen magnification software"
                    )
                  )
                ),
              ]),
            ]),
            _vm._v(" "),
            _c("h3", [
              _vm._v(
                _vm._s(
                  _vm.$t(
                    "accessibility.technical.technologies.title",
                    "Technologies Used"
                  )
                )
              ),
            ]),
            _vm._v(" "),
            _vm._m(1),
          ]
        ),
      ]),
      _vm._v(" "),
      _c(
        "footer",
        { staticClass: "statement-footer" },
        [
          _c("back-to-top-button"),
          _vm._v(" "),
          _c("p", { staticClass: "statement-meta" }, [
            _vm._v(
              "\n      " +
                _vm._s(
                  _vm.$t(
                    "accessibility.statement.prepared",
                    "This statement was prepared on"
                  )
                ) +
                " \n      " +
                _vm._s(_vm.formattedDate) +
                "\n    "
            ),
          ]),
        ],
        1
      ),
    ]
  )
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("address", [
      _vm._v("\n              GOZ Gaming Platform"),
      _c("br"),
      _vm._v("\n              Accessibility Team"),
      _c("br"),
      _vm._v("\n              123 Gaming Street"),
      _c("br"),
      _vm._v("\n              Digital City, DC 12345"),
      _c("br"),
      _vm._v("\n              European Union\n            "),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("ul", [
      _c("li", [_vm._v("HTML5 with semantic elements")]),
      _vm._v(" "),
      _c("li", [_vm._v("CSS3 with responsive design")]),
      _vm._v(" "),
      _c("li", [_vm._v("JavaScript (Vue.js)")]),
      _vm._v(" "),
      _c("li", [_vm._v("ARIA (Accessible Rich Internet Applications)")]),
      _vm._v(" "),
      _c("li", [_vm._v("Laravel (Backend framework)")]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }